
<div class="row mb-4">
  <div class="col">
    <p class="mt-2">Fill in or upload information to update assets serial numbers and MAC address.</p>
    <list-controls class="mb-3" [pageName]="'OrderStatus'" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
      <button class="btn btn-primary" id="saveOrder">Save</button>
    </list-controls>
    <input id="processing" type="checkbox" [(ngModel)]="filters.Processing" (change)="onListControlsChange('filter')">
    <label class="ml-2 mr-4" for="processing">Processing</label>
    <input id="acknowledged" type="checkbox" [(ngModel)]="filters.Acknowledged" (change)="onListControlsChange('filter')">
    <label class="ml-2 mr-4" for="acknowledged">Acknowledged</label>
    <input id="production" type="checkbox" [(ngModel)]="filters.Production" (change)="onListControlsChange('filter')">
    <label class="ml-2 mr-4" for="production">Production</label>
    <input id="shipped" type="checkbox" [(ngModel)]="filters.ShippedToCustomer" (change)="onListControlsChange('filter')">
    <label class="ml-2 mr-4" for="shipped">Shipped</label>
    <input id="delivered" type="checkbox" [(ngModel)]="filters.Delivered" (change)="onListControlsChange('filter')">
    <label class="ml-2 mr-4" for="delivered">Delivered</label>
    <input id="cancelled" type="checkbox" [(ngModel)]="filters.Cancelled" (change)="onListControlsChange('filter')">
    <label class="ml-2 mr-4" for="cancelled">Cancelled</label>
  </div>
</div>
<div class="row">
  <div class="col-12 mb-3" *ngFor="let asset of assets">
    <asset-status-card [asset]="asset"></asset-status-card>
  </div>
</div>